// extracted by mini-css-extract-plugin
export default {"trigger":"trigger__r76h0","trigger_s":"trigger_s__2sLsw","trigger_sm":"trigger_sm__hvUiw","trigger_m":"trigger_m__Nemkc","trigger_l":"trigger_l__1J9j7"};